import { Government } from '../../components/Government';
import { Roundboard } from '../../components/Roundboard';

export const Footer = (props) => {
  const {
    handleGovernmentRock = Function.prototype,
    handleGovernmentScissors = Function.prototype,
    handleGovernmentPaper = Function.prototype,
  } = props;
  return (
    <footer className='footer'>
      <div className='footer__left'>
        <div className='footer__info'>Выберите знак</div>
        <Government
          handleGovernmentRock={handleGovernmentRock}
          handleGovernmentScissors={handleGovernmentScissors}
          handleGovernmentPaper={handleGovernmentPaper}
        />
      </div>
      <div className='footer__right'>
        <Roundboard />
      </div>
    </footer>
  );
};
